import { render, staticRenderFns } from "./FormLimitedSubscription.vue?vue&type=template&id=06745f33&"
import script from "./FormLimitedSubscription.vue?vue&type=script&lang=js&"
export * from "./FormLimitedSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports